"use client";

export function Analytics() {
  return <></>;
}
